import { TaxDto } from "../../tax/Tax"
import { GroupDto } from "../Group"
import { PricingFeeCalculationDto } from "../PricingFeeCalculation"
import { PricingRowDto } from "../PricingRow"
import { PricingTotalDto } from "../PricingTotals"
import { ACTION_TYPES, Actions } from "../actions"
import { Handler } from "./handler"
import { PricingTableItemsStore } from "./types"

const defaultState: PricingTableItemsStore = {
    pricingTableItems: new Map<string, PricingRowDto>(),
    pricingTableGroups: new Map<string, GroupDto>(),
    pricingTableGroupItems: new Map<string, string[]>(),
    pricingTableId: new Map<string, string>(),
    pricingTableSelectedItems: new Map<string, Set<string>>(),
    pricingTableTax: new Map<string, Map<string, TaxDto>>(),
    pricingTableFees: new Map<string, PricingFeeCalculationDto[]>(),
    pricingTableTotals: new Map<string, PricingTotalDto[]>(),
    isBottomPriceEnabled: false,
    isWorkflowLoading: false,
}

function reducer(state = defaultState, action: Actions) {
    const handler = Handler(state)
    switch (action.type) {
    case ACTION_TYPES.SET_INITIAL_VALUES:
        return handler.getInitialState()
    case ACTION_TYPES.SET_PRICING_TABLE_GROUP_ITEMS:
        return handler.setPricingTableGroupItems(action.payload)
    case ACTION_TYPES.SET_PRICING_TABLE_ID:
        return handler.setPricingTableId(action.payload)
    case ACTION_TYPES.SET_PRICING_TABLE:
        return handler.setPricingTable(action.payload)
    case ACTION_TYPES.SET_PRICING_TABLE_TOTALS:
        return handler.setPricingTableTotals(action.payload)
    case ACTION_TYPES.SET_PRICING_TABLE_TAXES:
        return handler.setPricingTableTaxes(action.payload)
    case ACTION_TYPES.SET_PRICING_TABLE_FEES:
        return handler.setPricingTableFees(action.payload)
    case ACTION_TYPES.PRICING_TABLE_SET_SELECTED_ITEMS:
        return handler.setPricingTableSelectedItems(action.payload)
    case ACTION_TYPES.PRICING_TABLE_SELECTED_ITEMS_ADD_ITEM:
        return handler.addItemToSelectedItems(action.payload)
    case ACTION_TYPES.PRICING_TABLE_SELECTED_ITEMS_REMOVE_ITEM:
        return handler.removeItemFromSelectedItems(action.payload)
    case ACTION_TYPES.SET_PRICING_TABLE_ITEMS:
        return handler.setPricingTableItems(action.payload)
    case ACTION_TYPES.SET_PRICING_TABLE_GROUPS:
        return handler.setPricingTableGroups(action.payload)
    case ACTION_TYPES.SET_PRICING_TABLE_GROUP:
        return handler.setPricingTableGroup(action.payload)
    case ACTION_TYPES.SET_PRICING_TABLE_ITEM:
        return handler.setPricingTableItem(action.payload)
    case ACTION_TYPES.PRICING_TABLE_BOTTOM_PRICE_ENABLED:
        return handler.setBottomPriceEnabled(action.payload)
    case ACTION_TYPES.PATCH_PRICING_TABLE_ITEM_SUCCESS:
        return handler.patchPricingTableItem(action.payload)
    case ACTION_TYPES.DELETE_PRICING_TABLE_ITEM_SUCCESS:
        return handler.deletePricingTableItem(action.payload)
    case ACTION_TYPES.PATCH_PRICING_TABLE:
        return handler.patchPricingTable(action.payload)
    case ACTION_TYPES.PATCH_PRICING_TABLE_SUCCESS:
        return handler.patchPricingTableSuccess(action.payload)
    case ACTION_TYPES.PATCH_PRICING_TABLE_PENDING:
        return handler.patchPricingTablePending()
    case ACTION_TYPES.IS_WORKFLOW_LOADING:
        return handler.setIsWorkflowLoading(action.payload)
    case ACTION_TYPES.BULK_PATCH_PRICING_TABLE:
        return handler.bulkPatchPricingTable(action.payload)
    default:
        return state
    }
}

export default reducer


// WEBPACK FOOTER //
// ./src/state/pricing/reducers/reducer.ts